import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import TabsPageLayout from 'src/components/TabsPageLayout';
import { PORTAL_ROUTE } from 'src/constants/routes';
import { Box } from '@mui/material';
import { Loader } from 'src/components';
import { WDAC_SCRIPT_EXECUTION_PREVIOUS_PATH, wdacScriptExecutionTabs } from '../constants';
import useGetScriptExecutionDetails from '../../../../../queries/scriptExecutionDetails/useGetScriptExecutionDetails';

const ScriptExecutionTabs = () => {
  const { scriptExecutionId } = useParams();

  const { isLoading: scriptExecutionIsLoading, data } = useGetScriptExecutionDetails({ scriptExecutionId });

  const backNavigationPath = useMemo(() => {
    const storedPath = sessionStorage.getItem(WDAC_SCRIPT_EXECUTION_PREVIOUS_PATH);
    return storedPath || `${PORTAL_ROUTE}/wdac-results/script-execution`;
  }, []);

  if (scriptExecutionIsLoading) {
    return <Loader />;
  }

  return (
    <div>
      <TabsPageLayout
        hasBackButton
        title={
          <>
            <Box display="flex" alignItems="center" gap={1}>
              {data.fileName || 'No Display Name'}
            </Box>
          </>
        }
        tabs={wdacScriptExecutionTabs(scriptExecutionId, data.deviceCount)}
        backNavigationPath={backNavigationPath}
        wrapperProps={{
          sx: {
            maxWidth: '100%',
          },
        }}
        titleProps={{
          fontSize: '1.4rem',
        }}
      />
    </div>
  );
};

export default ScriptExecutionTabs;
